import React from 'react';
import Slider from 'react-slick';


class Arrow extends React.Component {
  constructor(props) {
    super(props);
    this.props=props;
    console.log(props);
    this.iconnames = {left:"chevron_right",right:"chevron_left"};
  }
  getDirection() {
    return this.props.direction.toLower();
  } 
  render() {
    return(<div {...this.props}>
      <a className="btn waves-effect waves-light" style={{
        padding:"0 1rem",
        position:"absolute",
        top:"calc(50% - 18px)",
        left:this.getDirection()=="right"?0:"initial",
        right:this.getDirection()=="left"?0:"initial",
        display:this.props.className.indexOf("slick-disabled")==-1?"block":"none"
        }}>
        <i className="material-icons">{this.iconnames[this.getDirection()]}</i>
      </a>
    </div>);  
  }
}

class LeftArrow extends Arrow {
  getDirection() {
    return "left";
  }
}

class RightArrow extends Arrow {
  getDirection() {
    return "right";
  }
}

export default class SlideShow extends React.Component {
  constructor(props) {
    super(props);
    this.props=props;
  }
  getSliderContents() {
	  return this.props.children.map((el,idx) => {
       return (<div key = {`slide${idx}`}>	
          {el}
       </div>)
    });
  }
  
  render() {
	  var settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };
    return (
      <div>
        <style>
          {`.slick-slider { 
            position: relative; display: block; box-sizing: border-box; -moz-box-sizing: border-box; -webkit-touch-callout: none; -webkit-user-select: none; -khtml-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; -ms-touch-action: pan-y; touch-action: pan-y; -webkit-tap-highlight-color: transparent; 
          }
          .slick-list { position: relative; overflow: hidden; display: block; margin: 0; padding: 0; }
          .slick-list:focus { outline: none; }
          .slick-list.dragging { cursor: pointer; cursor: hand; }
          
          .slick-track { -webkit-transform: translate3d(0, 0, 0); -moz-transform: translate3d(0, 0, 0); -ms-transform: translate3d(0, 0, 0); -o-transform: translate3d(0, 0, 0); transform: translate3d(0, 0, 0); }
          
          .slick-track { position: relative; left: 0; top: 0; display: block; }
          .slick-track:before, .slick-track:after { content: ""; display: table; }
          .slick-track:after { clear: both; }
          .slick-loading .slick-track { visibility: hidden; }
          
          .slick-slide { float: left; min-height: 1px; display: none; }
          
          .slick-slide img { display: block; }
          .slick-slide.slick-loading img { display: none; }
          .slick-slide.dragging img { pointer-events: none; }
          .slick-initialized .slick-slide { display: block; }
          .slick-loading .slick-slide { visibility: hidden; }
          .slick-vertical .slick-slide { display: block; height: auto; border: 1px solid transparent; }
         
          .slick-slider .slick-next,.slick-slider .slick-prev {
            visibility:hidden;
          } 
          .slick-slider:hover .slick-next,.slick-slider:hover .slick-prev {
            visibility:visible;
          }
          
          `}
        </style>
        
        <Slider {...settings} nextArrow={LeftArrow} prevArrow={RightArrow} {...this.props}>
          {this.getSliderContents()}  
        </Slider>
      
        
      </div>
    );
  }
}


SlideShow.propTypes = {
  afterChange: React.PropTypes.func,
  beforeChange: React.PropTypes.func
};


// WEBPACK FOOTER //
// ./src/js/components/SlideShow/SlideShow.jsx